"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const is_missing_or_white_space_1 = require("./is-missing-or-white-space");
/*
 * Checks if a string is present
 *
 * @Param {string} str = The string to check.
 *
 * @Example
 *
 *   isPresent('')
 *   //=> false
 *
 *   isPresent(null)
 *   //=> false
 *
 *   isPresent(undefined)
 *   //=> false
 *
 *   isPresent('banana')
 *   //=> true
 */
function isPresent(str) {
    return !is_missing_or_white_space_1.isMissingOrWhiteSpace(str);
}
exports.isPresent = isPresent;
//# sourceMappingURL=is-present.js.map